import { useGetCategoryOptions } from "../../common/public-options/useGetCategoryOptions";
import type { DataTableOption } from "../../../components/table";

interface UseMerchantOptionsReturn {
  categoryOptions: DataTableOption[];
  fetchCategoryOptions: () => Promise<void>;
  verificationOptions: DataTableOption[];
  badgeOptions: DataTableOption[];
}

const VERIFICATION_OPTIONS: DataTableOption[] = [
  { label: "Verified", value: "verified" },
  { label: "Pending", value: "pending" },
];

const BADGE_OPTIONS: DataTableOption[] = [
  { label: "None", value: "NONE" },
  { label: "Verified", value: "VERIFIED" },
  { label: "Trusted", value: "TRUSTED" },
  { label: "Premium", value: "PREMIUM" },
];

export const useMerchantOptions = (): UseMerchantOptionsReturn => {
  const { categoryOptions: rawCategoryOptions, fetchCategoryOptions } = useGetCategoryOptions();

  const categoryOptions: DataTableOption[] = rawCategoryOptions.map((option) => ({
    label: option.label,
    value: option.value,
  }));

  return {
    categoryOptions,
    fetchCategoryOptions,
    verificationOptions: VERIFICATION_OPTIONS,
    badgeOptions: BADGE_OPTIONS,
  };
};
